export const Constants = {
  TOKEN: '__t',
  SHOPPING_CART_DATA: 'SHOPPING_CART_DATA',
  DELIVERY_ADDRESS: 'DELIVERY_ADDRESS',
  DINING_METHOD: 'DINING_METHOD',
  TAKEAWAY_OPTIONS: 'TAKEAWAY_OPTIONS',
};

export const initialDelivery = 0;